<template>
	<div class="marketing-section bg-color-bg-tertiary">
		<div class="container">
			<InfoCardSingular :card="ourAssetsCard" theme="greige" />
		</div>
	</div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import InfoCardSingular from '@components/layout/info-card-singular.vue';
import { useAppStore } from '@stores/app';
import { InfoCard } from 'types/layout';

const appStore = useAppStore();

const ourAssetsCard = computed((): InfoCard => {
	return {
		heading: 'our assets',
		title: 'Your portfolio is powered by high-quality, resilient assets.',
		description: [
			'Fundrise offers a variety of proprietary funds, ranging from real estate private equity to venture capital to private credit. Historically, these kinds of investments would’ve been reserved exclusively for institutional investors.',
			'Depending on your objective, your portfolio will gain exposure to one or more of our high-end strategies, including',
			`
			<ul class="ul ml-150">
				<li>Build-for-rent residential housing across the Sunbelt</li>
				<li>Late-stage, high-growth private tech companies, including those focused on AI/ML</li>
				<li>Industrial assets like last-mile distribution warehouses and data centers</li>
				<li>High-yield opportunistic bridge loan financing</li>
			</ul>
				`,
			'We’ve invested in a multi-billion portfolio of private market assets over the last decade. We’re also one of 50 real estate private equity firms in the world to deploy more than $1 billion annually in both 2021 and 2022.'
		],
		link: {
			text: 'View all offerings',
			router: 'offerings'
		},
		imageUrl: `/images/marketing-site/how-it-works/fundrise-investment-real-estate-assets.avif`,
		fallbackImageUrl: `/images/marketing-site/how-it-works/fundrise-investment-real-estate-assets.png`
	};
});
</script>
